// Demo rows for the sales, clients and logs screens (split from mockData.ts for the file cap).

import type { SalesStage } from '../features/sales/useSales.js';
import type { ClientRow, ChargeRow } from '../features/clients/useClients.js';
import type { LogRow } from '../features/logs/useLogs.js';

export const MOCK_STAGES: SalesStage[] = [
  { id: 1, name: 'Ново', position: 1, color: '#94a3b8', is_terminal: false, terminal_kind: null },
  {
    id: 2,
    name: 'За контакт',
    position: 2,
    color: '#3b82f6',
    is_terminal: false,
    terminal_kind: null,
  },
  {
    id: 3,
    name: 'Говорих (рецепция)',
    position: 3,
    color: '#eab308',
    is_terminal: false,
    terminal_kind: null,
  },
  {
    id: 4,
    name: 'Говорих (собственик)',
    position: 4,
    color: '#f97316',
    is_terminal: false,
    terminal_kind: null,
  },
  { id: 5, name: 'Среща', position: 5, color: '#8b5cf6', is_terminal: false, terminal_kind: null },
  { id: 6, name: 'Оферта', position: 6, color: '#ec4899', is_terminal: false, terminal_kind: null },
  {
    id: 7,
    name: 'Спечелена',
    position: 7,
    color: '#10b981',
    is_terminal: true,
    terminal_kind: 'won',
  },
  {
    id: 8,
    name: 'Загубена',
    position: 8,
    color: '#ef4444',
    is_terminal: true,
    terminal_kind: 'lost',
  },
  {
    id: 9,
    name: 'Не безпокой',
    position: 9,
    color: '#64748b',
    is_terminal: true,
    terminal_kind: 'dnc',
  },
];

export const MOCK_CLIENTS: ClientRow[] = [
  {
    id: 1,
    lead_id: 2,
    business_name: 'Дента Център Лазур',
    status: 'active',
    package_key: 'pro',
    one_time_price_eur: 450,
    monthly_fee_eur: 140,
    billing_day: 1,
    go_live_date: '2026-06-01',
    notes: 'Основна клиника в Лазур с 3 кабинета.',
  },
  {
    id: 2,
    lead_id: 1,
    business_name: 'Дентално Студио Д-р Иванова',
    status: 'active',
    package_key: 'starter',
    one_time_price_eur: 300,
    monthly_fee_eur: 90,
    billing_day: 15,
    go_live_date: '2026-08-15',
    notes: 'Индивидуална естетична практика.',
  },
];

export const MOCK_CHARGES: ChargeRow[] = [
  {
    id: 1,
    client_id: 1,
    kind: 'fee',
    label: 'Месечна поддръжка (септември)',
    amount_eur: 140,
    status: 'paid',
    due_on: '2026-09-01',
    period_start: '2026-09-01',
    paid_at: '2026-09-01',
    supplier_paid_at: null,
  },
  {
    id: 2,
    client_id: 1,
    kind: 'fee',
    label: 'Месечна поддръжка (август)',
    amount_eur: 140,
    status: 'paid',
    due_on: '2026-08-01',
    period_start: '2026-08-01',
    paid_at: '2026-08-02',
    supplier_paid_at: null,
  },
  {
    id: 3,
    client_id: 2,
    kind: 'fee',
    label: 'Месечна поддръжка (септември)',
    amount_eur: 90,
    status: 'paid',
    due_on: '2026-09-01',
    period_start: '2026-09-01',
    paid_at: '2026-09-03',
    supplier_paid_at: null,
  },
  {
    id: 4,
    client_id: 2,
    kind: 'fee',
    label: 'Месечна поддръжка (октомври)',
    amount_eur: 90,
    status: 'due',
    due_on: '2026-10-01',
    period_start: '2026-10-01',
    paid_at: null,
    supplier_paid_at: null,
  },
  {
    id: 5,
    client_id: 1,
    kind: 'expense',
    label: 'Годишен домейн dentallazur.com',
    amount_eur: 45,
    status: 'due',
    due_on: '2026-09-15',
    period_start: null,
    paid_at: null,
    supplier_paid_at: '2026-09-10',
  },
];

export const MOCK_LOGS: LogRow[] = [
  {
    id: 1,
    site_id: 1,
    level: 'info',
    source: 'server',
    category: 'monitor',
    message: 'Успешна проверка на наличност (HTTP 200, 240ms)',
    context: { url: 'https://dentallazur.com', ssl_valid: true, days_until_expiry: 72 },
    fingerprint: null,
    happened_at: new Date(Date.now() - 1000 * 60 * 5).toISOString(),
  },
  {
    id: 2,
    site_id: 2,
    level: 'warn',
    source: 'browser',
    category: 'performance',
    message: 'Бавен First Contentful Paint (3.2s) от мобилно устройство',
    context: { user_agent: 'Mobile Safari / iOS 17', lcp_ms: 3200 },
    fingerprint: null,
    happened_at: new Date(Date.now() - 1000 * 60 * 25).toISOString(),
  },
  {
    id: 3,
    site_id: 1,
    level: 'info',
    source: 'server',
    category: 'backup',
    message: 'Автоматичен дневен бекъп на данни завършен успешно',
    context: { size_bytes: 4892010, duration_ms: 820 },
    fingerprint: null,
    happened_at: new Date(Date.now() - 1000 * 60 * 60).toISOString(),
  },
];
